<template>
  <div class="protocol_container">
    <div class="title_box">
      <div class="h2"><span>湖北日报新闻客户端及网站用户协议</span></div>
    </div>
    <div class="content_box">
      <div class="h3">一、总则</div>
      <div class="block_box">
        <p>
          1、为了保护网络信息安全，保障公民、法人和其他组织的合法权益，根据中华人民共和国法律法规，湖北日报客户端及网站制定并按照本协议提供湖北日报客户端及网站的网络服务。用户应当充分阅读并同意本协议的全部条款并按照页面上的提示完成全部的注册程序。用户在注册过程中点击“同意”按钮即表示用户完全接受本协议项下的全部条款，用户选择访问或使用湖北日报客户端及网站有关服务，将视为同意接受本协议全部条款的约束。
        </p>
        <p>
          2、除非另有明确规定，湖北日报客户端及网站所推出的新产品、新功能和新服务，均适用本协议。
        </p>
        <p>
          3、湖北日报客户端及网站保留在任何时候修改本协议条款的权利，用户在使用服务时应关注并遵守。
        </p>
        <p>
          4、用户在使用湖北日报客户端及网站提供的各项服务之前，应仔细阅读本协议。如果您不同意本协议或湖北日报客户端及网站的修改，可以主动取消湖北日报客户端及网站提供的服务；如果您继续使用湖北日报客户端及网站服务，则视为您已经接受本协议全部内容，包括湖北日报客户端及网站对本协议所做的任何修改。
        </p>
        <p>
          5、用户无论通过何种方式使用湖北日报客户端及网站服务，均受本协议约束。
        </p>
      </div>
      <div class="h3">二、用户帐号及权限</div>
      <div class="block_box">
        <p>
          1、用户可以通过在新闻客户端注册帐号使用湖北日报客户端及网站提供的各项服务。湖北日报客户端及网站帐号的所有权归湖北日报客户端及网站，用户完成申请注册手续后，获得湖北日报客户端及网站帐号的使用权，但仅限为个人而非商业目的使用。
        </p>
        <p>
          2、用户自行保管其帐号和密码。用户帐号、密码使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或者售卖。
        </p>
        <p>
          3、用户应提供完整、真实、准确和最新的个人资料，该资料对于使用湖北日报客户端及网站的服务以及找回丢失的湖北日报客户端及网站帐号和密码至关重要。如因注册信息不真实而引起的问题由用户本人承担，湖北日报客户端及网站不负任何责任并有权暂停或终止用户的帐号。
        </p>
        <p>
          4、用户帐号和密码遭到他人非法使用或发生其他任何安全问题，用户应当立即通知湖北日报客户端及网站。因黑客行为或用户的过错导致帐号、密码被他人非法使用，湖北日报客户端及网站不承担任何责任。
        </p>
      </div>
      <div class="h3">三、使用规则</div>
      <div class="block_box">
        <p>
          1、用户对以其帐号发生的或通过其帐号发生的一切活动和事件（包括但不限于用户发表的任何内容以及由此产生的任何结果）负全部法律责任。
        </p>
        <p>
          2、用户在使用湖北日报客户端及网站服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用湖北日报客户端及网站服务进行任何违法或不正当的活动，包括但不限于下列行为：
        </p>
        <p>
          (1) 上载、下载、张贴、以电子邮件发送、传输、存储或以其他方式提供任何非法、有害、胁迫、骚扰、侵权、中伤、粗俗、猥亵、诽谤、淫秽、暴力、侵害他人隐私、种族歧视或其他令人不快的包括但不限于资讯、资料、文字、软件、音乐、照片、图形、信息或其他资料（以下简称内容）。
        </p>
        <p>
          (2) 以任何方式危害未成年人。
        </p>
        <p>
          (3) 冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为与任何人或任何机构有关。
        </p>
        <p>
          (4) 伪造标题或以其他方式操控识别资料，使他人产生误解。
        </p>
        <p>
          (5) 上载、张贴、发送电子邮件或以其他方式传送无权传送的内容。
        </p>
        <p>
          (6) 侵犯他人著作权或其他知识产权，或违反保密、雇佣或不披露协议披露他人商业秘密或保密信息。
        </p>
        <p>
          (7) 张贴、发送、传输或以其他方式提供任何未经收件人请求或授权的电子邮件信息、广告、促销资料、垃圾邮件等，包括但不限于大批量的商业广告和信息公告。
        </p>
        <p>
          (8) 上载、张贴、以电子邮件发送、传输、存储或以其他方式提供包含病毒或包含旨在危害、干扰、破坏或限制有关服务（或其任何部分）或任何其他计算机软件、硬件或通讯设备之正常运行的任何其他计算机代码、文档或程序的任何资料。
        </p>
        <p>
          (9) 干扰或破坏有关服务，或与有关服务连接的任何服务器或网络，或与有关服务连接之网络的任何政策、要求或规定。
        </p>
        <p>
          (10)采集并存储涉及有关服务任何其他用户的个人信息，以用于任何上述被禁止的活动。
        </p>
        <p>
          (11)违反任何相关的中国法律、法规、规章、条例等其他具有法律效力的规范。
        </p>
        <p>
          3、湖北日报客户端及网站可能提供需要用户支付一定的费用的收费服务。对此，湖北日报客户端及网站会在用户使用前明示，只有用户根据提示确认其愿意支付相关费用，用户才能使用该等收费网络服务。如用户拒绝支付相关费用，则湖北日报客户端及网站有权不向用户提供该等收费网络服务。
        </p>
        <p>
          4、用户为使用湖北日报客户端及网站服务，须自行配备进入国际互联网所必需的设备，包括电脑、手机及其他与接入互联网或移动网有关的装置，并自行支付与此服务有关的费用。
        </p>
        <p>
          5、用户同意湖北日报客户端及网站有权在提供网络服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息。
        </p>
      </div>
      <div class="h3">四、知识产权</div>
      <div class="block_box">
        <p>
          1、湖北日报客户端及网站服务中包含的任何文字、图表、音频、视频和/或软件（包括但不限于软件中包含的图表、动画、音频、视频、界面、数据和程序、代码、文档）等信息或材料均受著作权法、商标法和/或其它法律法规的保护，未经相关权利人书面同意，用户不得以任何方式使用该等信息或材料，但出于使用湖北日报客户端及网站服务目的而使用的除外。
        </p>
        <p>
          2、本协议未授予用户使用湖北日报客户端及网站任何商标、服务标记、标识、域名和其他显著品牌特征的权利。
        </p>
        <p>
          3、除本协议明确允许的以外，用户不得以任何形式或任何方式对湖北日报客户端及网站服务部分或全部内容进行修改、出租、租赁、出借、出售、分发、复制、创作衍生品或用于任何商业用途。
        </p>
        <p>
          4、用户在湖北日报客户端及网站上发布的信息不得侵犯任何第三人的知识产权，未经相关权利人之事先书面同意，用户不得以任何方式上传、发布、修改、传播或复制任何受著作权保护的材料、商标或属于其他人的专有信息。
        </p>
        <p>
          5、用户同意，除非另有约定，对于其上传到本网站的任何内容，湖北日报客户端及网站在全世界范围内不限形式和载体地享有永久的、不可撤销的、免费的、非独家的使用权和转授权的权利，包括但不限于修改、复制、发行、展览、改编、汇编、出版、翻译、信息网络传播、广播、表演和再创作及著作权法等法律法规确定的其他权利，用户特别授权湖北日报客户端及网站以自己名义单独对第三方的侵权行为提起诉讼并获得全额赔偿。湖北日报客户端及网站无须为此向用户给予任何报酬或承担任何义务，也无须另行通知。
        </p>
      </div>
      <div class="h3">五、隐私政策</div>
      <div class="block_box">
        <p>
          隐私权保护声明是湖北日报客户端及网站保护用户个人隐私的承诺。鉴于网络的特性，湖北日报客户端及网站将无可避免地与您产生直接或间接的互动关系，故特此说明湖北日报客户端及网站对用户个人信息所采取的收集、使用和保护政策，请您务必仔细阅读《湖北日报客户端及网站隐私政策》
        </p>
      </div>
      <div class="h3">六、其他</div>
      <div class="block_box">
        <p>
          1、本协议的版权归湖北日报客户端及网站所有，湖北日报客户端及网站保留对本协议的一切解释和修改权利。
        </p>
        <p>
          2、本协议的订立、执行和争议的解决均应适用中华人民共和国法律。如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向湖北日报客户端及网站所在地有管辖权的人民法院提起诉讼。
        </p>
        <p>
          3、湖北日报客户端及网站未行使本协议的任何权利或规定，不构成对前述权利之放弃。
        </p>
        <p>
          4、如本协议中的任何条款完全或部分无效，本协议的其余条款仍有效并且有约束力。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { loadStat } from "@/utils";
export default {
  name: "Protocol",
  data() {
    return {};
  },
  methods: {},
  created() {
    document.title = "湖北日报新闻客户端及网站用户协议";
    loadStat(); // 友盟统计
  },
};
</script>
<style scoped lang="scss">
.protocol_container {
  width: 100%;
  height: 100%;
  padding: 15px;
  overflow-x: hidden;
  overflow-y: auto;
  * {
    word-break: normal;
    white-space: normal;
    line-height: 1.5em;
  }
  .title_box {
    .h2 {
      padding: 18px 0;
      line-height: 27px;
      text-align: center;
      color: #000;
      font-size: 18px;
      font-weight: bolder;
    }
  }
  .content_box {
    .h3 {
      margin-top: 10px;
      padding-bottom: 10px;
      color: #000;
      font-size: 17px;
      font-weight: bolder;
      text-indent: 2em;
    }
    p {
      margin: 5px 0;
      color: #000;
      font-family: "宋体";
      text-indent: 28px;
      text-align: justify;
    }
  }
}
</style>